module.exports = __webpack_public_path__ + "media/images/front/bg_products_header_01-be6ee20712f9cfab7028d6df0e8fb5c5.jpg";